export default function Step2() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="49" viewBox="0 0 48 49" fill="none">
            <g clipPath="url(#clip0_2914_1809)">
                <path d="M22.8394 8.43255C26.0052 11.5983 26.0052 16.7311 22.8394 19.8969C21.8713 20.865 20.7192 21.5371 19.4956 21.9131L19.4956 42.5265L14.7188 42.5265V21.9131C13.4953 21.5371 12.3432 20.865 11.3751 19.8969C8.20927 16.7311 8.20928 11.5983 11.3751 8.43255C12.3432 7.46443 13.4953 6.79236 14.7188 6.41635L14.7188 13.687L19.4956 13.687L19.4956 6.41635C20.7192 6.79238 21.8713 7.46443 22.8394 8.43255Z" stroke="black" stroke-width="2.57143" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M30 25.7002C30 25.1479 30.4477 24.7002 31 24.7002H37C37.5523 24.7002 38 25.1479 38 25.7002V41.7002C38 42.2525 37.5523 42.7002 37 42.7002H31C30.4477 42.7002 30 42.2525 30 41.7002V25.7002Z" stroke="black" stroke-width="2.57143"/>
                <path d="M31.6 13.9002V24.7002H36.4V13.9002L38 11.5002L36.4 6.7002H31.6L30 11.5002L31.6 13.9002Z" stroke="black" strokeWidth="2.57143" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
            <defs>
                <clipPath id="clip0_2914_1809">
                    <rect width="48" height="48" fill="white" transform="translate(0 0.700195)"/>
                </clipPath>
            </defs>
        </svg>
    );
}
